module.exports = __webpack_public_path__ + "img/02_Paddy_s.65a18a6e.png";